"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Combobox = exports.menuStyle = exports.Item = exports.Input = void 0;

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactAutocomplete = _interopRequireDefault(require("react-autocomplete"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _zIndices = _interopRequireDefault(require("./zIndices"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Input = _styledComponents.default.input.withConfig({
  displayName: "Combobox__Input",
  componentId: "is1dz3-0"
})(["box-sizing:border-box;width:100%;max-width:100%;height:calc(2em + 2px);padding:0.375em 1.5em 0.375em 0.75em;border-color:#6c757d;border-style:solid;border-width:1px;border-radius:0.25em;background-image:url('data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7');background-position:center right;background-repeat:no-repeat;cursor:pointer;font-size:1em;line-height:1.25;outline:none;&:focus{box-shadow:0 0 0 0.2em ", ";}"], (0, _polished.transparentize)(0.5, '#428bca'));

exports.Input = Input;

var Item = _styledComponents.default.div.withConfig({
  displayName: "Combobox__Item",
  componentId: "is1dz3-1"
})(["padding:0.375em 0.75em;background:", ";cursor:pointer;font-size:14px;"], function (props) {
  return props.isHighlighted ? (0, _polished.transparentize)(0.5, '#428bca') : 'none';
});

exports.Item = Item;
var menuStyle = {
  position: 'fixed',
  zIndex: _zIndices.default.popover,
  overflow: 'auto',
  maxHeight: '50%',
  padding: '2px 0',
  borderRadius: '3px',
  background: '#fff',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)'
};
exports.menuStyle = menuStyle;

var Combobox = /*#__PURE__*/function (_Component) {
  _inherits(Combobox, _Component);

  var _super = _createSuper(Combobox);

  function Combobox(_props) {
    var _this;

    _classCallCheck(this, Combobox);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, inputValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        inputValue: inputValue
      });

      onChange(inputValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value, item) {
      var onSelect = _this.props.onSelect;

      _this.setState({
        inputValue: item.label
      });

      onSelect(item);
    });

    _defineProperty(_assertThisInitialized(_this), "shouldItemRender", function (item) {
      var inputValue = _this.state.inputValue;
      return item.label.toLowerCase().includes(inputValue.toLowerCase());
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (props) {
      var id = _this.props.id; // eslint-disable-next-line react/prop-types

      var ref = props.ref,
          rest = _objectWithoutProperties(props, ["ref"]);

      return /*#__PURE__*/_react.default.createElement(Input, _extends({}, rest, {
        id: id,
        ref: ref
      }));
    });

    _this.state = {
      inputValue: _props.value
    };
    return _this;
  }

  _createClass(Combobox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          placeholder = _this$props.placeholder,
          renderOption = _this$props.renderOption,
          value = _this$props.value,
          width = _this$props.width;
      var inputValue = this.state.inputValue;
      return /*#__PURE__*/_react.default.createElement(_reactAutocomplete.default, {
        getItemValue: function getItemValue(item) {
          return item.label;
        },
        inputProps: {
          onBlur: function onBlur() {
            _this2.setState({
              inputValue: value
            });
          },
          onFocus: function onFocus() {
            _this2.setState({
              inputValue: ''
            });
          },
          placeholder: placeholder
        },
        items: options,
        menuStyle: menuStyle,
        renderInput: this.renderInput,
        renderItem: function renderItem(item, isHighlighted) {
          return /*#__PURE__*/_react.default.createElement(Item, {
            key: item.label,
            isHighlighted: isHighlighted
          }, renderOption(item));
        },
        shouldItemRender: this.shouldItemRender,
        value: inputValue,
        wrapperStyle: {
          display: 'inline-block',
          width: width
        },
        onChange: this.onChange,
        onSelect: this.onSelect
      });
    }
  }]);

  return Combobox;
}(_react.Component);

exports.Combobox = Combobox;

_defineProperty(Combobox, "propTypes", {
  id: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onSelect: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes.default.string,
  renderOption: _propTypes.default.func,
  value: _propTypes.default.string.isRequired,
  width: _propTypes.default.string
});

_defineProperty(Combobox, "defaultProps", {
  id: undefined,
  onChange: function onChange() {},
  placeholder: undefined,
  renderOption: function renderOption(option) {
    return option.label;
  },
  width: undefined
});